import React from 'react';
import { Link } from 'gatsby';

import { posters } from '../../../video-posters';

interface PosterProps {
  poster: typeof posters[0];
}

function Poster({ poster }: PosterProps) {
  return (
    <div className="p-4 lg:w-1/3">
      <div className="h-full bg-gray-100 bg-opacity-75 px-4 py-8 rounded-lg overflow-hidden text-center relative flex flex-col">
        <h2 className="tracking-widest text-xs title-font text-gray-400 mb-1">
          VIDEO POSTER
        </h2>
        <h2 className="mb-3 flex-1 flex">
          <span className="my-auto sm:text-xl text-base font-medium text-gray-900">
            {poster.title}
          </span>
        </h2>
        <p className="leading-relaxed mb-3">
          {poster?.authors?.map((author) => author.name)?.join(', ')}
        </p>
        <Link
          to={`/poster/${poster.slug}`}
          className="text-blue-500 inline-flex items-center mt-auto ml-auto"
        >
          Ver más
          <svg
            className="w-4 h-4 ml-2"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 12h14" />
            <path d="M12 5l7 7-7 7" />
          </svg>
        </Link>
      </div>
    </div>
  );
}

export default function VideoPosters() {
  return (
    <div className="text-gray-600 body-font">
      <div className="container px-5 py-24 mx-auto">
        <div className="flex flex-wrap -m-4">
          {posters.map((poster) => (
            <Poster key={poster.slug} poster={poster} />
          ))}
        </div>
      </div>
    </div>
  );
}
